import React from 'react'
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import Contact_layout from '../contact_content/Contact_layout';
const Contact = () => {
  return (
    <>
    <Navbar/>
    <Contact_layout/>
    <Footer/>
    </>
  )
}

export default Contact